import { render, staticRenderFns } from "./UploadChannelPicture.html?vue&type=template&id=0f90a7a9&scoped=true&"
import script from "./UploadChannelPicture.js?vue&type=script&lang=js&"
export * from "./UploadChannelPicture.js?vue&type=script&lang=js&"
import style0 from "./UploadChannelPicture.scss?vue&type=style&index=0&id=0f90a7a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90a7a9",
  null
  
)

export default component.exports